export enum AppRoleType {
  System = 1,
  Business = 2,
}
